import { createFileRoute } from "@tanstack/react-router";
import type { FC } from "react";
import { Page500 } from "../../../../components/templates/Page500";

const InternalServerError: FC = () => {
  return <Page500 />;
};

export const Route = createFileRoute("/_private/_errors/error/")({
  component: InternalServerError,
});
